<rpshared-save-bar
	title="{{ form.value.firstName }} {{ form.value.lastName }}"
	[isSaving]="isSaving$ | async"
	[isFormInvalid]="invalidSubmission$ | async"
	(save)="save($event)"
></rpshared-save-bar>

<div class="toolbar-margin"></div>

<div [formGroup]="form">
	<mat-card>
		<mat-progress-bar
			mode="indeterminate"
			class="mat-card-loading"
			*ngIf="isLoading$ | async"
		></mat-progress-bar>
		<rpshared-card-title
			icon="verified_user"
			title="Admin User Details"
		></rpshared-card-title>
		<div gdGap="8px" gdColumns="repeat(auto-fill, minmax(350px, 1fr))">
			<mat-form-field>
				<input
					matInput
					placeholder="First Name"
					formControlName="firstName"
					autofocus
				/>
			</mat-form-field>
			<mat-form-field>
				<input
					matInput
					placeholder="Last Name"
					formControlName="lastName"
				/>
			</mat-form-field>
			<mat-form-field>
				<input
					matInput
					placeholder="Email"
					formControlName="email"
					type="email"
				/>
			</mat-form-field>

			<rpshared-field-worker-link
				required
				formControlName="fieldWorker"
			></rpshared-field-worker-link>

			<rpshared-multi-chip-input
				gdColumn="-1 / 1"
				formControlName="roles"
			></rpshared-multi-chip-input>
		</div>
	</mat-card>
</div>
